export default __webpack_public_path__ + "fefd1328b7aca494bf7617caedc0f91b.png";